import React from 'react';
import { useSelector } from 'react-redux';
import Popup from '../../../../ui/popup/Popup';
import HeaderPopup from '../../../../ui/popup/headerPopup/HeaderPopup';
import ContentsPopup from '../../../../ui/popup/contentPopup/ContentPopup';
import classes from './FinalEntryPopup.module.css';

const FinalEntryPopup = ({ onClose }) => {
  const { texts } = useSelector((state) => state.translate);

  return (
    <Popup close={onClose} dropClass={classes.popup} accessibilityDescription={texts.finalEntryTeamTitle} className={classes.breakPopup}>
      <HeaderPopup title={texts.finalEntryTeamTitle} className={classes.header} />
      <ContentsPopup className={classes.content}>
        <p className={classes.text}>{texts.schoolFinalAccessText}</p>
        <button  onClick={onClose} className={classes.button}>
          {texts.goodLuckToThem}
        </button>
      </ContentsPopup>
    </Popup>
  );
};

export default FinalEntryPopup;
